import React from 'react';
import parse from 'html-react-parser';

import { Modal } from '../../../../../components/general';

import { updateEmailText } from '../../../../../services/emailTemplatesService';

import { useProjectStore } from '../../../../../stores/project';
import { useProjectSettingsStore } from '../../../../../stores/projectSettings';
import { useUserStore } from '../../../../../stores/user';

import { SGTemplate } from '../../../../../types';

const EmailPreviewModal = (props: {
  show: boolean;
  onHide: () => void;
  template: SGTemplate;
  customText?: string;
}) => {
  const { show, onHide, template, customText } = props;

  const { user } = useUserStore();
  const { currentProject } = useProjectStore();
  const { footer } = useProjectSettingsStore();

  if (!user || !currentProject) return null;

  const projectName = currentProject.name;
  const userName = user.firstName;

  const emailHtml = updateEmailText({
    text: template.html_content ?? '',
    projectName,
    userName,
    customText,
    footer,
  });

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <b>Subject</b>:{' '}
          {updateEmailText({
            text: template.subject ?? '',
            projectName,
            userName,
          })}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-0">
        <div>{parse(emailHtml)}</div>
      </Modal.Body>

      <Modal.Footer className="text-sm italic">
        Please note that all links (if existing) in the preview are substituted
        with www.crowdclip.com. The emails your attendees receive will include
        all relevant links.
      </Modal.Footer>
    </Modal>
  );
};

export default EmailPreviewModal;
